import React, { useState, Fragment, useEffect } from 'react';
import {
  Row,
  Input,
  Label,
  CustomInput,
  NavItem,
  Nav,
  NavLink,
  Button,
  Modal,  
  ModalHeader,
  ModalBody,
  ModalFooter,
  FormGroup,
  InputGroup,
  CardImg,
  InputGroupAddon,
  InputGroupText, Tooltip,
  TabContent,TabPane
} from 'reactstrap';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import ImageGallery from '../../views/app/pages/propinfo/gallery/index';
import { Colxx } from '../../components/common/CustomBootstrap';
import timeZoneOptions from '../../data/timeZone';
import currencies from '../../data/currencies';
import { AxiosAPI } from '../../helpers/AxiosAPI';
import { gAPI_Internal_Property_By_Id,postAPI_Update_Property } from '../../constants/APIs';
import Select from 'react-select';
import country from '../../data/country';
import { reactSelectOptionDiffrentPro } from '../../helpers/Utils';
import timeZoneList from '../../data/timeZoneList';
import currencyList from '../../data/currencyList';
import moment from 'moment';
import { NotificationManager } from '../../components/common/react-notifications';
import classnames from 'classnames';
import Validation from '../../components/Validation';
export function BusinessProfile({
  visible,
  toggle,
  groupId,
  propertyId
}) {
  const [selectedCountry, setSelectedCountry] = useState({
    value: '',
    label: 'Please Select',
  });  
  const [open,setOpen] = useState(false);
  const [msg,setMsg] =useState([]);
  const [selectZones, setSelectZones] = useState();
  const [startDate, setStartDate] = useState(null);
  const [activeTab, setActiveTab] = useState('businessInfo');
  const [galleryVisible, setGalleryVisible] = useState(false);
  const [logoGalleryVisible, setLogoGalleryVisible] = useState(false);
  const [propertyData, setpropertyData] = useState({
      groupId: groupId,
      type: 'hotel',
      name: '',
      currency: 'NZD',
      inventoryProvider: 'None',
      ratesProvider: 'None',
      bookingProvider: 'None',
      timeZone: 'None',
      ariUrl: '',
      bookingUrl: '',
      creator: 'Manually',
      isTemplate: false,
      displayOrder: 1,
      country: 'NZ',
      status: 'Active',
      websiteLink: '',
      rooms: 0,
      starRating: 0,
      images: 'https://via.placeholder.com/150/',
      bmbAccountManager: '',
      bmbVoucherProcessingFee: 0,
      customerSuccessManager: '',
      isBmb: false,
      isAiva: false,
      isVirtualFrontDesk: false,
      isRateBooking: false,
      activationDate: null,
      redeemAddress: '',
      averageDailyRate: 0,
      legalBusinessName: '',
      businessAddress: '',
      pdfSettings: {
        Logo: '',
        Phone: '',
        Email: '',
        Website: '',
        Terms: '',
        RedeemInstructions: ''
      }
    }
  );
  const [tooltipOpen, setTooltipOpen] = useState(false);
  useEffect(() => {
    if (propertyId !== undefined && propertyId !== "-1") {
        AxiosAPI({
            methhod: 'get',
            url: `${gAPI_Internal_Property_By_Id}/${propertyId}?group_id=${groupId}`,
        })
            .then((res) => {
                setStartDate(moment(res.data.activationDate).format('MMM DD, YYYY') === 'Jan 01, 0001' ? null
                    : moment(res.data.activationDate));
                setpropertyData(res.data);
                // let currency = currencyList.filter(item => item.countryCode === res.data.country);
                let timeZones = timeZoneList.filter(
                    (item) => item.IsoAlpha2 === res.data.country
                );
                const countryGroup = country.filter(
                    (item) => item.code === res.data.country
                );
                let countrySelected = {
                    value: countryGroup[0].code,
                    label: countryGroup[0].name,
                };
                setSelectedCountry(countrySelected);
                // setpropertyData({
                //     ...propertyData,
                //     country: value.value,
                //     currency: currency[0].currencyCode
                // });

                setSelectZones(
                    timeZones[0].TimeZones.map((zone) => {
                        return <option value={zone}>{zone}</option>;
                    })
                );
            })
            .catch((err) => console.log('err', err));
    }
}, [propertyId]);
  const handleChange = (e) => {
    setpropertyData({
      ...propertyData,
      [e.target.name]: e.target.value,
    });
  };
  const handleRateChange = (e) => {
    setpropertyData({
      ...propertyData,
      starRating: e.rating,
    });
  };
  const handleCheckedChange = (e) => {
    setpropertyData({
      ...propertyData,
      [e.target.name]: e.currentTarget.checked,
    });
  };
  const togglegallery = () => {
    // setImageIndex(index);
    setGalleryVisible(!galleryVisible);
  };

  const toggleLogogallery = () => {
    // setImageIndex(index);
    setLogoGalleryVisible(!logoGalleryVisible);
  };



  const selectedImage = (image) => {
    setpropertyData({
      ...propertyData,
      images: image.src,
    });
  };

  const selectedLogo = (image) => {
    let settings = propertyData.pdfSettings;
    settings.logo = image.src;
    setpropertyData({ ...propertyData, pdfSettings: settings });
  };


  const LogoGalleryButton = () => {
    return (
      <Row>
        <Colxx xs="12" sm="12" md="12" lg="12" className="mb-4">
          <Row>
            <Colxx xs="12" sm="3" className="mb-1">
              <Modal
                isOpen={logoGalleryVisible}
                toggle={toggleLogogallery}
                style={{ maxWidth: '1000px' }}
              >
                <ModalHeader toggle={toggleLogogallery}>
                  Select Image or Upload New Image
                </ModalHeader>
                <ModalBody>
                  <ImageGallery
                    selectedImage={selectedLogo}
                    togglegallery={toggleLogogallery}
                    hideUserUploads={false}
                    searchText={''}
                  />
                </ModalBody>
              </Modal>
            </Colxx>
          </Row>
        </Colxx>
      </Row>
    );
  };
  const ImageGalleryButton = () => {
    return (
      <Row>
        <Colxx xs="12" sm="12" md="12" lg="12" className="mb-4">
          <Row>
            <Colxx xs="12" sm="3" className="mb-1">
              <Modal
                isOpen={galleryVisible}
                toggle={togglegallery}
                style={{ maxWidth: '1000px' }}
              >
                <ModalHeader toggle={togglegallery}>
                  Select Image or Upload New Image
                </ModalHeader>
                <ModalBody>
                  <ImageGallery
                    selectedImage={selectedImage}
                    togglegallery={togglegallery}
                    hideUserUploads={false}
                    searchText={''}
                  />
                </ModalBody>
              </Modal>
            </Colxx>
          </Row>
        </Colxx>
      </Row>
    );
  };
  const handleChangeSelect = (value, { name }) => {
    let currency = currencyList.filter(
      (item) => item.countryCode === value.value
    );
    let timeZones = timeZoneList.filter(
      (item) => item.IsoAlpha2 === value.value
    );
    setpropertyData({
      ...propertyData,
      country: value.value,
      currency: currency[0].currencyCode,
      timeZone: timeZones[0].TimeZones[0],
    });
    setSelectedCountry(value);
    setSelectZones(
      timeZones[0].TimeZones.map((zone) => {
        return <option value={zone}>{zone}</option>;
      })
    );
  };

  const handleSubmit = () => {
    const formmatedData = { ...propertyData, updater: 'admin' };
    AxiosAPI({
        method: 'put',
        url: `${postAPI_Update_Property}/${propertyId}`,
        data: formmatedData,
    }).then((res) => {
      if (res.data.HttpStatusCode !== undefined && res.data.HttpStatusCode === 400 && res.data.Messages !== undefined
        && res.data.Messages !== null && res.data.Messages.length > 0) {
          setMsg(res.data.Messages);
          setOpen(true);
      }
      else {
        NotificationManager.success(
            "",
            "Profile update successfully",
            3000,
            null,
            null,
            "success"
        );
        toggle();
      }
    });
};

  const selectTimeZoneOptions = timeZoneOptions
    .sort(dynamicSort('label'))
    .map((item) => {
      return <option value={item.value}>{item.label}</option>;
    });

  const selectCurrencies = currencies.sort(dynamicSort('label')).map((item) => {
    return <option value={item.value}>{item.label}</option>;
  });

  function dynamicSort(property) {
    var sortOrder = 1;
    if (property[0] === '-') {
      sortOrder = -1;
      property = property.substr(1);
    }
    return function (a, b) {
      /* next line works with strings and numbers,
       * and you may want to customize it to your needs
       */
      var result =
        a[property] < b[property] ? -1 : a[property] > b[property] ? 1 : 0;
      return result * sortOrder;
    };
  }
  const handleChangeDate = (date) => {
    setpropertyData({ ...propertyData, activationDate: moment(date) });
  };

  const handlePdfSettings = (e) => {
    let settings = propertyData.pdfSettings;
    if (e.target.name === 'phone') {
      settings.phone = e.target.value;
    } else if (e.target.name === 'email') {
      settings.email = e.target.value;
    }
    else if (e.target.name === 'website') {
      settings.website = e.target.value;
    }
    else if (e.target.name === 'terms') {
      settings.terms = e.target.value;
    }
    else if (e.target.name === 'redeemInstructions') {
      settings.redeemInstructions = e.target.value;
    }

  }
  return (
    <Fragment>
      <Modal isOpen={visible} toggle={toggle} size="lg">
        <ModalHeader toggle={toggle}>Bussiness Profile</ModalHeader>
        <ModalBody>
          <Nav tabs className="card-header-tabs ml-0 mr-0 mb-3">
            <NavItem className=" text-center" style={{ width: 'auto', background: '' }}>
              <NavLink
                style={{ background: 'none', cursor: 'pointer' }}
                className={classnames({
                  active: activeTab === "businessInfo",
                  "nav-link": true
                })}
                onClick={() => {
                  setActiveTab("businessInfo");
                }}
                to="#"
              >
                <span style={{ color: `${activeTab === "businessInfo" ? '#EF4A81' : 'black'}` }}>Business Info</span>
              </NavLink>
            </NavItem>
            {propertyData.pdfSettings !== undefined && <NavItem className=" text-center" style={{ width: 'auto' }}>
              <NavLink
                style={{ background: 'none', cursor: 'pointer' }}
                className={classnames({
                  active: activeTab === "voucherInfo",
                  "nav-link": true
                })}
                onClick={() => {
                  setActiveTab("voucherInfo");
                }}
                to="#"
              >
                <span style={{ color: `${activeTab === "voucherInfo" ? '#EF4A81' : 'black'}` }}>Voucher Info</span>
              </NavLink>
            </NavItem>}
          </Nav>
          <TabContent activeTab={activeTab} className="">
            <TabPane tabId="businessInfo" className="chat-app-tab-pane">
              <Row className="">
                <Colxx xxs="12">                  
                  <Row>
                    <Colxx sm={12} className="mb-3">
                    <Label>Bussiness Name <i className="demo-icon simple-icon-info" id="titletip"></i></Label>
                                    <Tooltip
                                        placement="right"
                                        isOpen={tooltipOpen}
                                        target="titletip"
                                        toggle={() => setTooltipOpen(!tooltipOpen)}
                                    >
                                        A short title which will appear when users ask about the bussiness profile
                                    </Tooltip>
                      <Input
                        type="text"
                        value={propertyData.name}
                        onChange={handleChange}
                        name="name"
                      />
                    </Colxx>
                    <Colxx sm={12} className="mb-3">
                                    <Label>Bussiness Website</Label>
                                    <Input
                                        type="text"
                                        value={propertyData.websiteLink}
                                        onChange={handleChange}
                                        name="websiteLink"
                                    />
                                </Colxx>
                                <Colxx sm={12} className="mb-3">
                                    <Label>Bussiness Type</Label>
                                    <Input
                                        type="select"
                                        value={propertyData.type}
                                        name="type"
                                        onChange={handleChange}
                                    >
                                        <option value="Hotel">Hotel</option>
                                        <option value="Motel">Motel</option>
                                        <option value="Lodge">Lodge</option>
                                        <option value="Resort">Resort</option>
                                        <option value="CampGround">CampGround</option>
                                        <option value="Bach">Bach</option>
                                        <option value="Hostel">Hostel</option>
                                        <option value="Pub">Pub</option>
                                    </Input>
                                </Colxx>                    
                    <Colxx sm={6} className="mb-3">
                      <Label>Country</Label>
                      <Select
                        isMulti={false}
                        className="react-select"
                        classNamePrefix="react-select"
                        name="code"
                        placeholder="Select Country"
                        onChange={handleChangeSelect}
                        value={selectedCountry}
                        options={
                          country
                            ? reactSelectOptionDiffrentPro(
                              country,
                              true,
                              'code',
                              'name',
                              ''
                            )
                            : []
                        }
                      />
                    </Colxx>            
                    {selectZones !== undefined && selectZones.length > 0 && (
                      <Colxx sm={6} className="mb-3">
                        <Label>Time Zone</Label>
                        <Input
                          type="select"
                          value={propertyData.timeZone}
                          name="timeZone"
                          onChange={handleChange}
                        >
                          {selectZones}
                        </Input>
                      </Colxx>
                    )}
                  </Row>
                </Colxx>
                 
                <Colxx sm={12} className="mb-3">
                    <Label>Legal Business Name</Label>
                    <Input
                      type="text"
                      value={propertyData.legalBusinessName}
                      name="legalBusinessName"
                      onChange={handleChange}
                    >
                    </Input>
                </Colxx>
                  <Colxx sm={12} className="mb-3">
                    <Label>Business Address</Label>
                    <Input
                      type="text"
                      value={propertyData.businessAddress}
                      name="businessAddress"
                      onChange={handleChange}
                    >
                    </Input>
                  </Colxx>
                <Fragment>
             <Colxx sm={12}>
                  <h4>Logo</h4>
                </Colxx>
                  <Colxx sm={12}>
                    <Row>
                      <Colxx sm={2} className="md-3">
                        <img
                          style={{
                            width: '100%',
                            height: '90%',
                          }}
                          alt="room image"
                          src={
                            propertyData.images || 'https://via.placeholder.com/150/'
                          }
                        />
                      </Colxx>
                      <Colxx sm={1} className="mb-3">
                        <Label>Browse</Label>
                        <div
                          className="iconsminds-photo"
                          onClick={(event) => togglegallery()}
                          style={{
                            cursor: 'pointer',
                            fontSize: '28px',
                            color: '#73236b',
                          }}
                        ></div>
                      </Colxx>
                    </Row>
                  </Colxx>
               
                </Fragment>

              </Row>
              {ImageGalleryButton()}             
            </TabPane>
            <TabPane tabId="voucherInfo" className="chat-app-tab-pane">
              {propertyData.pdfSettings !== undefined &&
              <Row className="">
                <Colxx xxs="12">
                  <Row className="text-center mt-3">
                  <Colxx sm={12} className="mb-3">
                      <CardImg
                        top
                        src={propertyData.pdfSettings.logo}
                        alt=""
                        className="img-thumbnail border-0 rounded-circle list-thumbnail"
                      />
                    </Colxx>
                    <Colxx sm={12} className="mb-3">
                    <Button
                      color="success"
                      size="xs"
                      className="mt-1"
                      onClick={toggleLogogallery}
                    >
                      Browse GrayScale Logo
                    </Button>
                  </Colxx>
                  <Colxx sm={12} className="mb-3">
                    <Label>Phone#</Label>
                    <Input
                      name="phone"
                      defaultValue={propertyData.pdfSettings.phone}
                      onChange={(e) => handlePdfSettings(e)}
                    />
                  </Colxx>

                  <Colxx sm={12} className="mb-3">
                    <Label>Email</Label>
                    <Input
                      name="email"                    
                      defaultValue={propertyData.pdfSettings.email}
                      onChange={(e) => handlePdfSettings(e)}
                    />
                  </Colxx>

                  <Colxx sm={12} className="mb-3">                    
                    <Label>Website</Label>
                    <Input
                      name="website"
                      defaultValue={propertyData.pdfSettings.website}
                      onChange={(e) => handlePdfSettings(e)}
                    />
                  </Colxx>
                  <Colxx sm={12} className="mb-3 ">
                    <Label>General Terms</Label>

                    <Input
                      name="terms"    
                      type="textarea"                            
                      maxLength={400}
                      defaultValue={propertyData.pdfSettings.terms}
                      onChange={(e) => handlePdfSettings(e)}
                    />
                  </Colxx>
                  <Colxx sm={12} className="mb-3 text-start">
                    <Label>Redeem Instructions</Label>

                    <Input
                      name="redeemInstructions"
                      type="textarea"                   
                      defaultValue={propertyData.pdfSettings.redeemInstructions}
                      onChange={(e) => handlePdfSettings(e)}
                    />
                  </Colxx>
                  </Row>
                </Colxx>
              </Row>}
              {LogoGalleryButton()}
            </TabPane>
          </TabContent>
        </ModalBody >
        <ModalFooter>
          <Button color="primary" onClick={handleSubmit}>
            Save
          </Button>
          <Button color="secondary" onClick={toggle}>
            Cancel
          </Button>
        </ModalFooter>
      </Modal >
      <Validation open={open} messages={msg} toggle={()=>{setOpen(!open)}}></Validation>
    </Fragment >
  );
}
